import { create } from "zustand";
import {
  createItinerarySlice,
  ItinerarySliceV2,
} from "./slices/itienrarySlice";
import { createUserSlice, UserSlice } from "./slices/userSlice";

type ItineraryStore2 = UserSlice & ItinerarySliceV2

export const useItineraryStoreV2 = create<ItineraryStore2>()((...a) => ({
  ...createUserSlice(...a),
  ...createItinerarySlice(...a),
}));
